module.exports = __webpack_public_path__ + "static/img/logo11.36674f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo11.png
// module id = zxUT
// module chunks = 1